/**
 * Pantalla: FitxUrb
 * Component: PantFitxUrb.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu
 * Versió: 1.1
 * Data: 19/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 * Per generar al fitxa urbanística
 */

import * as React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, IconButton, Menu, MenuItem, Tooltip, Typography } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { MapComponent } from '@terrestris/react-geo';
import OlLayerImage from 'ol/layer/Image';
import OlImageSource from 'ol/source/Image';
import OlLayerTile from 'ol/layer/Tile';
import OlTileSource from 'ol/source/Tile';
import { IPropsMapa } from '../interfaces/IPropsMapa';
import FitxUrbState from '../states/FitxUrbState';
import RefCadAdrWidget from '../controls/RefCadAdrWidget';
import MyLayerSwitcher from '../controls/MyLayersSwitcher';
import MyLayerSwitcher2 from '../controls/MyLayersSwitcher2';
import MyZoomToExtent from '../controls/MyZoomToExtent';
import MyCustomControl from '../controls/MyCustomControl';
import HorizontalCollapse from '../controls/HorizontalCollapse';
import { IFincaNumero, IRefCad } from '../interfaces/IRefCadAdr';
import 'ol/ol.css';
import 'antd/dist/antd.min.css';
import '../css/react-geo.css';
import '../css/MyControls.css';
import '../css/Mapa.css';
import '../css/FitxUrb.css';
import { EnvironmentOutlined, CloseOutlined, FullscreenExitOutlined, CameraOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { ExpandMore, ArrowBackIos, ArrowForwardIos, Link, GpsFixed, DescriptionOutlined, PrintOutlined, GetAppOutlined, Portrait, HomeWorkOutlined } from '@material-ui/icons';
import { ILayer, ILayerGroup } from '../interfaces/ILayer';
import { AppDrawer, AppToolBar, AppToolBarElements } from 'ajt-app';
import Util from '../config/util';
import CotaIcon from '@material-ui/icons/SettingsEthernet';
import AreaIcon from '@material-ui/icons/AspectRatio';

@inject('appState')
@observer
export default class PantFitxUrb extends React.Component<IPropsMapa, object> {
    constructor(props: IPropsMapa) {
        super(props);
        // Creem el mpState - Els paràmetres el processem dins de createMap de FitxUrbState
        this.fuState = new FitxUrbState(this.props);
        // Events pel canvi de mida de la pantalla
        this.fuState.updateWindowSize();
        this.autoSize = true;
    }
 
    // El estat del mapa
    private fuState: FitxUrbState;
 
    // Diu si agafem les mides de la pantalla
    private autoSize = false;
    private readonly resizeHandler = this.updateDimensions.bind(this);

    updateDimensions() {
        if (this.autoSize) {
            this.fuState.updateWindowSize();
        }
    }
    
    // Per posar si cal la resposta a l'event de resize
    componentDidMount() {
        if (this.autoSize) {
            window.addEventListener('resize', this.resizeHandler);
        }
    }
      
    // Per treure si cal la resposta a l'event de resize
    componentWillUnmount() {
        if (this.autoSize) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }
    
    // Hem canviat de BaseLayer
    private handleBaseLayerChanged = (layerSelected: OlLayerTile<OlTileSource> | OlLayerImage<OlImageSource>) => {
       this.fuState.actBaseLayer = layerSelected;
       // La capa de noms només la volem activa als layers de Planejament i Ortofoto
        if (this.fuState.nomsLayer) {
            const id: string = layerSelected.get('id');
            const ld: ILayer = this.fuState.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
            if (ld && ld.noms) {
               this.fuState.nomsLayer.set('visible', this.fuState.nomsVisible);
               this.fuState.setShowNoms(true);
            } else {
               this.fuState.nomsLayer.set('visible', false);
               this.fuState.setShowNoms(false);
            }
        }
    }
 
    // Hem triat una finca o una adreça del control de text
    private handleOnChange = (e?: IFincaNumero) => {
        if (e) {
            if (e.NUMCOD) {
                this.fuState.setFIDFromNumCod(e.NUMCOD);
                this.fuState.setHCExpanded(false);
            } else if (e.FINCOD) {
                this.fuState.setFIDFromFinCod(e.FINCOD);
                this.fuState.setHCExpanded(false);
            } else if (e.FINREFCAD1 && e.FINREFCAD2) {
                this.fuState.setFIDFromRefCad(e.FINREFCAD1, e.FINREFCAD2);
                this.fuState.setHCExpanded(false);
            } else if (e.COORD && e.COORD.length === 2) {
                this.fuState.setIdentMode(1);
                this.fuState.setFIDFromPos(e.COORD);
                this.fuState.setHCExpanded(false);
            } else {
                this.fuState.setFIDFromNumCod(0);
            }
        } else {
            this.fuState.setFIDFromNumCod(0);
        }
    }
 
    // Anar a la posició actual del mòbil
    private handleGotoMyLocation = () => {
        this.fuState.setActualLocation();
    }

    // Començar a buscar una posició
    private handleMyShowPhoto = () => {
        this.fuState.setIdentPosition(2);
    }

    // Començar a buscar una posició (parcel·la)
    private handleMySetPosition = () => {
        this.fuState.setIdentMode(1);
        this.fuState.setIdentPosition(1);
    }

    // Començar a buscar una posició (punt)
    private handleMySetPoint = () => {
        this.fuState.setIdentMode(2);
        this.fuState.setIdentPosition(1);
    }

    // Esborrar la posició
    private handleMyDelPosition = () => {
        this.fuState.setIdentPosition(0);
    }

    // Recentrar mapa
    private handleMyCenterPosition = () => {
        this.fuState.zoomToPosition();
    }
    
    // Per posar l'estat del HorizontalCollapse
    private handleHCToggle = () => {
        this.fuState.setHCExpanded(!this.fuState.hcExpanded);
    }
 
    // Activem o desactivem la capa de noms
    private handleCBNomsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.fuState.nomsLayer.setVisible(event.target.checked);
        this.fuState.setNomsVisible(event.target.checked);
    };

    // Activem o desactivem la capa de texts d'edificació
    private handleCBTxConsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.fuState.txconsLayer.setVisible(event.target.checked);
        this.fuState.setTxConsVisible(event.target.checked);
    };

    // Activem o desactivem una capa de referència
    private handleCBRefLayerChange = (id: string, event: React.ChangeEvent<HTMLInputElement>) => {
        const i = this.fuState.getRefLayerIndex(id);
        if (i >= 0) {
            this.fuState.refLayers[i].setVisible(event.target.checked);
            this.fuState.setRefLayerVisible(i, event.target.checked, false);
        }
    }

    // Rederitza un Layer o un LayerGroup
    private renderLayerComponent = (ly: ILayer | ILayerGroup, mrg?: number) => {
        mrg = (mrg ? mrg : 0);
        if (ly.type === 'wms' || ly.type === 'wmts') {
            const rll: ILayer = ly as ILayer;
            if (rll.legend && rll.legend.length > 0) {
                return (<Accordion square elevation={0} style={{padding: 0, left: mrg, minHeight: 20}} key={'ac' + rll.id}>
                    <AccordionSummary key={'gr' + rll.id} expandIcon={<ExpandMore />} style={{height: 32, maxHeight: 32, minHeight: 20}}>
                        <FormControlLabel 
                            style={{fontSize: '12px', padding: 0, marginLeft: -6}} 
                            key={'fcl' + rll.id}
                            control={<><Checkbox 
                                key={'cb' + rll.id}
                                checked={this.fuState.actRefLayers[this.fuState.getRefLayerIndex(rll.id)]} 
                                onChange={this.handleCBRefLayerChange.bind(this, rll.id)} 
                                name={rll.id}
                                style={{padding: 0}}  
                            />{!!rll.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rll.icon} alt={rll.name} width={16} height={16}/>&nbsp;</>}</>}
                            label={<Typography variant="body2">{rll.name}</Typography>} 
                        />
                    </AccordionSummary>
                    <AccordionDetails style={{display: 'grid', padding: '0px 16px 0px 16px', minHeight: 20}} key={'acd' + rll.id}>
                        {rll.legend.map((lg) => { return (<FormControlLabel 
                            style={{fontSize: '12px', padding: 0, marginLeft: 10}} 
                            key={'fclg' + lg.name}
                            control={<>{!!lg.icon && <><img src={process.env.PUBLIC_URL + '/img/' + lg.icon} alt={lg.name} width={16} height={16}/>&nbsp;</>}</>}
                            label={<Typography variant="body2">{lg.name}</Typography>} 
                        />); })}
                    </AccordionDetails>
                </Accordion>);
            } else {
                return (<Accordion square elevation={0} style={{padding: 0, left: mrg, minHeight: 20}} expanded={false} key={'ac' + rll.id}>
                    <AccordionSummary key={'gr' + rll.id} style={{height: 32, maxHeight: 32, minHeight: 20}}>
                        <FormControlLabel 
                            style={{fontSize: '12px', padding: 0, marginLeft: -6}} 
                            key={'fcl' + rll.id}
                            control={<><Checkbox 
                                key={'cb' + rll.id}
                                checked={this.fuState.actRefLayers[this.fuState.getRefLayerIndex(rll.id)]} 
                                onChange={this.handleCBRefLayerChange.bind(this, rll.id)} 
                                name={rll.id}
                                style={{padding: 0}}  
                            />{!!rll.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rll.icon} alt={rll.name} width={16} height={16}/>&nbsp;</>}</>}
                            label={<Typography variant="body2">{rll.name}</Typography>} 
                        />
                    </AccordionSummary>
                </Accordion>);
            }
        } else if (ly.type === 'grp') {
            const rlg = ly as ILayerGroup;
            return (<Accordion square elevation={0} style={{padding: 0, left: mrg, minHeight: 20}} key={'ac' + rlg.id} defaultExpanded={rlg.expanded}>
                <AccordionSummary key={'gr' + rlg.id} expandIcon={<ExpandMore />} style={{height: 32, maxHeight: 32, minHeight: 20}}>
                    {!!rlg.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rlg.icon} alt={rlg.name} width={16} height={16}/>&nbsp;</>}
                    <Typography variant="body2">{rlg.name}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{display: 'grid', padding: 0, minHeight: 20}} key={'acd' + rlg.id}>
                    {rlg.layers.map((rl) => { return this.renderLayerComponent(rl, mrg + 10); })}
                </AccordionDetails>
            </Accordion>);
        } else {
            return null;
        }
    }

    // Retrona el nom del layer si està actiu. si és un grup retorna els noms dels layers actius de dins del grup
    private getActiveLayer = (ly: ILayer | ILayerGroup): string => {
        if (ly.type === 'wms' || ly.type === 'wmts') {
            const rll: ILayer = ly as ILayer;
            if (this.fuState.actRefLayers[this.fuState.getRefLayerIndex(rll.id)]) {
                return rll.layers;
            }
        } else if (ly.type === 'grp') {
            const rlg = ly as ILayerGroup;
            const lys: Array<string> = rlg.layers.map((rl) => { return this.getActiveLayer(rl); });
            if (lys.length > 0) {
                let slys: string = lys.join(',');
                let slys2: string = Util.replaceAll(slys, ',,', ',');
                while (slys !== slys2) {
                    slys = slys2;
                    slys2 = Util.replaceAll(slys, ',,', ',');
                }
                if (slys.endsWith(',')) {
                    slys = slys.substring(0, slys.length - 1);
                }
                return slys;
            }
        }
        return '';
    }

    private handlePhotoClose = () => {
        this.fuState.photoIndex = -1;
        this.fuState.photoArray = [];
        this.fuState.photoAdr = '';
    }

    private handlePhotoBack = () => {
        let i = this.fuState.photoIndex - 1;
        if (i < 0) {
            i = this.fuState.photoArray.length - 1;
        }
        this.fuState.photoIndex = i;
    }

    private handlePhotoFordward = () => {
        let i = this.fuState.photoIndex + 1;
        if (i >=  this.fuState.photoArray.length) {
            i = 0;
        }
        this.fuState.photoIndex = i;
    }

    private handleFmtMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.fuState.setAnchorFmtEl(event.currentTarget)
    }

    private handleFmtMenuClose = (format: string) => {
        this.fuState.setAnchorFmtEl(null);
        this.fuState.setFormat(format);
    }

    private handleSclMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.fuState.setAnchorSclEl(event.currentTarget)
    }

    private handleSclMenuClose = (scale: string) => {
        this.fuState.setAnchorSclEl(null);
        this.fuState.setScale(scale);
    }

    /** Dibuixem mesures
     * @param measureType Tipus de mesura
     */
    private handleMeasureMenuItemClick = (measureType: string) => {
        this.fuState.setMapInteraction(measureType);
    };
    
    // Mostra un diàleg amb l'enllaç
    private handleGetLink = () => {
        // Posar un popup amb el link
        // Protocol i host
        let url: string = window.location.protocol + '//' + window.location.hostname;
        // Port
        if (window.location.port && window.location.port !== '80' && window.location.port != '443') {
            url += ':' + window.location.port;
        }
        // Path
        url += window.location.pathname;
        // BaseLayer
        const id: string = this.fuState.actBaseLayer.get('id');
        const ld: ILayer = this.fuState.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
        url += '?Base=' + ld.layers;
        // RefLayers
        const lys: Array<string> = this.fuState.mapConfig.refLayers.map((rl) => {
            return this.getActiveLayer(rl);
        })
        if (lys.length > 0) {
            let slys: string = lys.join(',');
            let slys2: string = Util.replaceAll(slys, ',,', ',');
            while (slys !== slys2) {
                slys = slys2;
                slys2 = Util.replaceAll(slys, ',,', ',');
            }
            if (slys.endsWith(',')) {
                slys = slys.substring(0, slys.length - 1);
            }
            if (slys.startsWith(',')) {
                slys = slys.substring(1);
            }
            if (slys) {
                url+= '&Layers=' + slys;
            }
        }

        // Referència cadastral o posició
        if (this.fuState.finCod) {
            if (!this.fuState.finRefCad1 || !this.fuState.finRefCad2) {
                this.fuState.refCadWebApi.getRefCad(this.fuState.finCod).then((resultrc: IRefCad) => {
                    this.fuState.finRefCad1 = resultrc.FINREFCAD1;
                    this.fuState.finRefCad2 = resultrc.FINREFCAD2;
                    url += '&RefCad=' + this.fuState.finRefCad1 + this.fuState.finRefCad2;
                    this.props.appState.dialState.messageBox({    
                        title: 'Enllaç',
                        message: url,
                        buttons: navigator.clipboard ? ['Copiar URL', 'Acceptar'] : ['Acceptar']
                    }).then((result) => {
                        if (result === 'Copiar URL') {
                            navigator.clipboard.writeText(url);
                            this.props.appState.notiState.showMessage('URL copiada');
                        }
                    });
                }).catch(() => { / * No fa res * / }); 
            } else {
                url += '&RefCad=' + this.fuState.finRefCad1 + this.fuState.finRefCad2;
                this.props.appState.dialState.messageBox({    
                    title: 'Enllaç',
                    message: url,
                    buttons: navigator.clipboard ? ['Copiar URL', 'Acceptar'] : ['Acceptar']
                }).then((result) => {
                    if (result === 'Copiar URL') {
                        navigator.clipboard.writeText(url);
                        this.props.appState.notiState.showMessage('URL copiada');
                    }
                });
            }    
        } else {
            // Centre del mapa i Zoom
            const c = this.fuState.olview.getCenter();
            url += '&Pos=' + c[0].toFixed(2) + ';' + c[1].toFixed(2) + ';' + this.fuState.olview.getZoom().toFixed(0);
            this.props.appState.dialState.messageBox({    
                title: 'Enllaç',
                message: url,
                buttons: navigator.clipboard ? ['Copiar URL', 'Acceptar'] : ['Acceptar']
            }).then((result) => {
                if (result === 'Copiar URL') {
                    navigator.clipboard.writeText(url);
                    this.props.appState.notiState.showMessage('URL copiada');
                }
            });
        }
    }

    // Mostra la pre-visulatizació de la fitxa urbanística
    private handleShowPrevFU = () => {
        this.fuState.showPrevFitxUrb();
    }

    // Imprimeix la fitxa urbanística
    private handlePrintFU = () => {
        this.fuState.printFitxUrb();
    }

    // Salta a la pantalla de propietaris i habitants
    private handleShowHab = () => {
        window.open(this.fuState.mapConfig.habUrl + "?RefPar=" + this.fuState.finRefCad1 + this.fuState.finRefCad2);
    }

    // Slata a la pantalla del banc de dades
    private handleShowBBDD = () => {
        window.open(this.fuState.mapConfig.bbddUrl + "?Conn=AJT.INF&Ref1=" + this.fuState.finRefCad1 + "&Ref2=" + this.fuState.finRefCad2);
    }

    render () {
        if (!this.fuState.configOk) {
            return null;
        }

        const w: number = this.fuState.width; // Amplada de la finestra
        const drw: number = this.props.appState.menuState.marginDrawer; // Amplada el drawer
        const wx: string = (w - drw).toString() + 'px'; // Amplada del mapa

        const mto: string = w < 601 ? (w < 600 ? '96px' : '112px') : '112px'; // Posició top del mapa
        const h: number = this.fuState.height - 106 + (w < 601 ? (w < 600 ? 16 : 8) : 0); // Alçada del mapa
        const hx: string = h.toString() + 'px'; // Alçada del mapa

        const lx: string = w < 601 ? '.5em' : 'calc(50% - ' + ((w / 2) - 270) + 'px)'; // Esquerra del layer switcher
        const bx: string = 'calc(100% - ' + (h + ( w < 601 ? 80 : 90)).toString() + 'px)'; // Bottom del layer switcher

        const txr = w < 601 ? (w < 600 ? '106px' : '122px') : '122px'; // Top del cercador
        const lxr: string = w < 601 ? '2.5em' : 'calc(50% - ' + ((w / 2) - 300) + 'px)'; // Esquerra del cercador
        const wxr = (w - (w < 601 ? 45 : 310)).toString() + 'px'; // Amplada del crecador quan està desplegat

        const thc = w < 601 ? (w < 600 ? '106px' : '122px') : '122px';  // Posició (superior) del control de capa de noms
        const rhc = 'calc(100% - ' + (w + 5).toString() + 'px)'; // Posició (dreta) del control de capa de noms

        const thc2 = this.fuState.showNoms ? (w < 601 ? (w < 600 ? '148px' : '164px') : '164px') : thc; // Posició (superior) del control de capa de texts d'edificació

        return (
            <>
                <AppToolBar style={{zIndex: 1300}} showHelp={true}>
                    <AppToolBarElements alignment='left'>
                        <Tooltip title="Previsualització fitxa urbanística">
                            <IconButton onClick={this.handleShowPrevFU} key="ibprev" disabled={!this.fuState.finRefCad1}>
                                <DescriptionOutlined />
                            </IconButton>
                        </Tooltip>
                        <Button onClick={this.handleFmtMenuClick} variant='outlined' disabled={!this.fuState.finRefCad1}>{this.fuState.fmt + ' ˅'}</Button>
                        <Menu
                            id="simple-menu_fmt"
                            anchorEl={this.fuState.anchorFmtEl}
                            keepMounted
                            open={Boolean(this.fuState.anchorFmtEl)}
                            onClose={this.handleFmtMenuClose.bind(this, this.fuState.fmt)}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center', }}
                        >
                            <MenuItem key={'dsc_png'} onClick={this.handleFmtMenuClose.bind(this, 'PNG')}>PNG</MenuItem>
                            <MenuItem key={'dsc_pdf'} onClick={this.handleFmtMenuClose.bind(this, 'PDF')}>PDF</MenuItem>
                            <MenuItem key={'dsc_dxf'} onClick={this.handleFmtMenuClose.bind(this, 'DXF')}>DXF</MenuItem>
                        </Menu>
                        <Button onClick={this.handleSclMenuClick} variant='outlined' disabled={!this.fuState.finRefCad1}>{this.fuState.sclDesc + ' ˅'}</Button>
                        <Menu
                            id="simple-menu_scl"
                            anchorEl={this.fuState.anchorSclEl}
                            keepMounted
                            open={Boolean(this.fuState.anchorSclEl)}
                            onClose={this.handleSclMenuClose.bind(this, this.fuState.scl)}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center', }}
                        >
                            <MenuItem key={'dsc_auto'} onClick={this.handleSclMenuClose.bind(this, 'A')}>{'Auto'}</MenuItem>
                            {`${this.props.appState.entorn}` !== 'internet' && <MenuItem key={'dsc_500'} onClick={this.handleSclMenuClose.bind(this, '5C')}>{'1:500'}</MenuItem>}
                            <MenuItem key={'dsc_1000'} onClick={this.handleSclMenuClose.bind(this, '1M')}>{'1:1000'}</MenuItem>
                            <MenuItem key={'dsc_2000'} onClick={this.handleSclMenuClose.bind(this, '2M')}>{'1:2000'}</MenuItem>
                            <MenuItem key={'dsc_5000'} onClick={this.handleSclMenuClose.bind(this, '5M')}>{'1:5000'}</MenuItem>
                        </Menu>
                        <Tooltip title={(this.fuState.fmt === 'DXF' ? 'Decarregar' : 'Imprimir') + ' fitxa urbanística'}>
                            <IconButton onClick={this.handlePrintFU} key="ibprev" disabled={!this.fuState.finRefCad1}>
                                {this.fuState.fmt === 'DXF' ? <GetAppOutlined /> : <PrintOutlined />}                                
                            </IconButton>
                        </Tooltip>
                        {this.fuState.mapConfig.measureTool && <Tooltip title="Mesurar longitud">
                            <IconButton onClick={this.handleMeasureMenuItemClick.bind(this, 'l')} key="mdistance">
                                <CotaIcon />
                            </IconButton>
                        </Tooltip>}
                        {this.fuState.mapConfig.measureTool && <Tooltip title="Mesurar àrea">
                            <IconButton onClick={this.handleMeasureMenuItemClick.bind(this, 'a')} key="marea">
                                <AreaIcon />
                            </IconButton>
                        </Tooltip>}
                        {`${this.props.appState.entorn}` !== 'internet' && this.fuState.mapConfig.habUrl && <Tooltip title="Propietaris i habitants">
                            <IconButton onClick={this.handleShowHab} key="ibhab" disabled={!this.fuState.finCod}>
                                <Portrait />
                            </IconButton>
                        </Tooltip>}
                        {`${this.props.appState.entorn}` !== 'internet' && this.fuState.mapConfig.bbddUrl && <Tooltip title="Banc de dades">
                            <IconButton onClick={this.handleShowBBDD} key="ibbbdd" disabled={!this.fuState.finCod}>
                                <HomeWorkOutlined />
                            </IconButton>
                        </Tooltip>}
                    </AppToolBarElements>
                    <AppToolBarElements alignment='right'>
                        <Tooltip title="Enllaçar">
                            <IconButton onClick={this.handleGetLink} key="iblink">
                                <Link />
                            </IconButton>
                        </Tooltip>
                    </AppToolBarElements>
                </AppToolBar>
                <AppDrawer variant={ w < 601 ? 'temporary' : 'permanent'}>
                    {
                        this.fuState.mapConfig.refLayers.map((rl) => {
                            return this.renderLayerComponent(rl);
                        })
                    }
                </AppDrawer>
                <>
                    {this.fuState.refCadWebApi && <HorizontalCollapse
                        style={{zIndex: 2, backgroundColor: 'rgba(250, 250, 250, 0.8)', position: 'absolute', left: lxr, top: txr}}
                        expandedWidth={wxr}
                        expanded={this.fuState.hcExpanded}
                        onToggleExpanded={this.handleHCToggle}
                        text={'Cercador'}
                    >
                        <RefCadAdrWidget
                            proxyWebApi={this.fuState.refCadWebApi}
                            numCod={this.fuState.numCod}
                            finCod={this.fuState.finCod}
                            // finRefCad1={this.fuState.finRefCad1}
                            // finRefCad2={this.fuState.finRefCad2}
                            onChange={this.handleOnChange}
                            floatingLabelText="Cercar per adreça o referència cadastral"
                        />
                    </HorizontalCollapse>}
                    {this.fuState.olmap && <MapComponent map={this.fuState.olmap} style={{width: wx, height: hx, cursor: this.fuState.identPosition ? 'crosshair' : this.fuState.identElement ? 'pointer' : 'default', position: 'fixed', top: mto}}/>}
                    {this.fuState.olmap && <MyZoomToExtent map={this.fuState.olmap} tooltip="Zoom total" extent={this.fuState.mapConfig.initialExtent}/>}
                    {this.fuState.olmap && <MyCustomControl
                        map={this.fuState.olmap} 
                        className="my-1-position" 
                        icon={GpsFixed}
                        tooltip="Centrar el mapa a la posició actual"
                        onClick={this.handleGotoMyLocation}
                        key="mycc1"
                    />}
                    {this.fuState.olmap && <MyCustomControl
                        map={this.fuState.olmap} 
                        className="my-2-position" 
                        icon={EnvironmentOutlined}
                        tooltip="Identificar una parcel·la"
                        onClick={this.handleMySetPosition}
                        key="mycc2"
                    />}
                    {this.fuState.olmap && <MyCustomControl
                        map={this.fuState.olmap} 
                        className="my-3-position" 
                        icon={InfoCircleOutlined}
                        tooltip="Informació urbanística d'un punt"
                        onClick={this.handleMySetPoint}
                        key="mycc3"
                    />}
                    {this.fuState.olmap && <MyCustomControl
                        map={this.fuState.olmap} 
                        className="my-4-position" 
                        icon={CameraOutlined}
                        tooltip="Mostrar la fotografia de la façana"
                        onClick={this.handleMyShowPhoto}
                        key="mycc4"
                    />}
                    {false && this.fuState.olmap && !!this.fuState.position && <MyCustomControl
                        map={this.fuState.olmap} 
                        className="my-4-position" 
                        icon={CloseOutlined}
                        tooltip="Esborrar el marcador"
                        onClick={this.handleMyDelPosition}
                        hidden={!this.fuState.position}
                        key="mycc4"
                    />}
                    {false && this.fuState.olmap && !!this.fuState.position && <MyCustomControl
                        map={this.fuState.olmap} 
                        className="my-5-position" 
                        icon={FullscreenExitOutlined} 
                        tooltip="Centrar el mapa al marcador"
                        onClick={this.handleMyCenterPosition}
                        hidden={!this.fuState.position}
                        key="mycc5"
                    />}
                    {this.fuState.baseLayers.length === 2 && <MyLayerSwitcher
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2
                        }}
                        map={this.fuState.olmap}
                        layers={this.fuState.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls1"
                    />}
                    {this.fuState.baseLayers.length > 2 && <MyLayerSwitcher2 
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2,
                            backgroundColor: 'rgba(250, 250, 250, 0.8)'
                        }}
                        map={this.fuState.olmap}
                        layers={this.fuState.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls2"
                    />}
                    {this.fuState.showNoms && <FormControlLabel 
                        style={{zIndex: 1, backgroundColor: 'rgba(250, 250, 250, 0.9)', position: 'absolute', right: rhc, top: thc, width: '160px'}}
                        control={<Checkbox 
                            checked={this.fuState.nomsVisible} 
                            onChange={this.handleCBNomsChange} 
                            name="cbNoms"   
                        />}
                        label={<Typography variant="body2">{this.fuState.nomsLayer.get('name')}</Typography>} 
                        title='Activar o desactivar la capa de noms de carrers i de números postals'
                    />}
                    {this.fuState.showTxCons && <FormControlLabel 
                        style={{zIndex: 1, backgroundColor: 'rgba(250, 250, 250, 0.9)', position: 'absolute', right: rhc, top: thc2, width: '160px'}}
                        control={<Checkbox 
                            checked={this.fuState.txConsVisible} 
                            onChange={this.handleCBTxConsChange} 
                            name="cbTxCons"   
                        />}
                        label={<Typography variant="body2">{this.fuState.txconsLayer.get('name')}</Typography>} 
                        title={'Activar o desactivar la capa de texts d\'edificació'}
                    />}
                    {this.fuState.photoIndex >= 0 && <Dialog 
                        onClose={this.handlePhotoClose}
                        open={this.fuState.photoIndex >= 0}
                    >
                        <DialogTitle disableTypography style={{padding: '0px 0px 0px 24px'}}>
                            <span className={'fitxurb-popup-content'}><b>{this.fuState.photoAdr}</b></span>
                            <div className={'fitxurb-popup-closer'} onClick={this.handlePhotoClose} />
                        </DialogTitle>
                        <DialogContent>
                            <img style={{maxWidth: '500px', maxHeight: '400px'}} src={this.fuState.mapConfig.wsPhoto + '?Photo=' + this.fuState.photoArray[this.fuState.photoIndex] + '&Usuari=' + this.fuState.usr + '&Session=' + this.fuState.ses} />
                            {this.fuState.photoArray.length > 1 && <>
                                <IconButton onClick={this.handlePhotoBack} style={{float: 'left', position: 'absolute', left: '10px', top: '50%'}} key="ib1">
                                    <ArrowBackIos />
                                </IconButton>
                                <IconButton onClick={this.handlePhotoFordward} style={{float: 'right', position: 'absolute', right: '10px', top: '50%'}} key="ib2">
                                    <ArrowForwardIos />
                                </IconButton>
                            </>}
                        </DialogContent>
                    </Dialog>}
                </>
            </>
        );
    }
}